import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import  Text  from './text.js';
import './About.css';

class AboutForm extends Component {
  state = {
    redirect: false
  }
  setRedirect = () => {
    this.setState({
      redirect: true
    })
  }
  renderRedirect = () => {
    if (this.state.redirect) {
      return <Redirect to='/yantra' />
    }
  }
  
  render() {
    return (
      <div className="form-div about">
        <Text />
      </div>
    )
  }
}

export default AboutForm;



// WEBPACK FOOTER //
// ./src/components/About/AboutForm.js